<ng-container *ngFor="let message of MessageQueue | keyvalue;">
  <ngb-alert [type]="message.value.Level" (close)="Close(message.value.Id)">
    <strong>{{message.value.Title}}</strong>
    {{message.value.Message}}
  </ngb-alert>
</ng-container>
